function Header() {
  return (
    <header>
      <nav className="navbar navbar-expand-lg navbar-light bg-nav">
        <a className="navbar-brand text-white" href="#">
          Maphs Hire
        </a>
        <button
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse " id="navbarSupportedContent">
          <ul className="navbar-nav ml-auto">
            <li className="nav-item active">
              <a className="nav-link text-white" href="#">
                Home <span className="sr-only">(current)</span>
              </a>
            </li>
          </ul>
        </div>
      </nav>

      <div className="header-content d-flex flex-column justify-content-center align-items-center text-white">
        <div className="slogan text-center">Your Ultimate Service</div>
        <div className="call-to-action text-center">
          Call Us Today
          <br />
          (+2779)-079-7625&nbsp;/&nbsp;(+2782)-966-6398
        </div>
      </div>
    </header>
  );
}

export default Header;
